<template>
    <div class="hype-aktien-landing-page bg-white font-body">
        <!-- 1) TOP NAV -->
        <nav class="bg-white border-b border-gray-200 sticky top-0 z-50">
            <div class="container mx-auto px-4 py-4 flex justify-between items-center">
                <!--Logo-->
                <router-link to="/" class="flex items-center gap-2">
                    <img class="w-32 h-auto hidden lg:block" :src="$asset('/hkcm/images/logo-on-light-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
                    <img class="w-[50px] h-auto block lg:hidden" :src="$asset('/hkcm/images/logo-small-on-light-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
                </router-link>
                <router-link
                    v-if="!ShowPreLiveCountdown"
                    to="/produkte/Hype-Aktien"
                    class="bg-blue text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-sm lg:text-md"
                >
                    Hype-Aktien-Paket entdecken
                </router-link>
            </div>
        </nav>

        <!-- 2) HERO -->
        <section class="relative hero bg-gradient-to-br from-blue-dark via-blue-dark to-blue py-20 text-white pb-64">
            <img class="z-0 absolute left-0 hidden lg:block w-full" :src="$asset('/hkcm/images/bg_candels.png', 'public')" />
            <div class="relative z-10 container mx-auto px-4 text-center">
                <!-- Badge-Reihe -->
                <div class="flex justify-center gap-4 mb-8">
                    <img
                        alt="Black Bull Krypto Insider"
                        class="h-full object-cover max-w-[5rem] max-h-[5rem]"
                        :src="$asset('/hkcm/images/partners/BlackBull24_Krypto_square.png', 'public')"
                    />

                    <img
                        alt="Black Bull Krypto Insider"
                        class="h-full object-cover max-w-[5rem] max-h-[5rem]"
                        :src="$asset('/hkcm/images/partners/BlackBull25_InvestmentVision.png', 'public')"
                    />

                    <div class="w-24 h-24 rounded-lg">
                        <img
                            alt="Black Bull Krypto Insider"
                            class="w-full object-contain max-h-[180px] lg:w-auto"
                            :src="$asset('/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png', 'public')"
                        />
                    </div>
                </div>

                <!-- H1 -->
                <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 max-w-5xl mx-auto">
                    <span class="bg-gradient-to-r from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Hype-Aktien-Paket:</span><br />
                    Tägliche Analyse trendstarker Wachstumsaktien
                </h1>

                <!-- Subheadline -->
                <p class="text-lg md:text-xl mb-10 max-w-6xl mx-auto text-gray-200">
                    Ausgewählte Trendaktien mit hohem Momentum und Marktinteresse. Tägliche Analysen mit klaren Zielzonen und präzisen Marktprognosen nach Elliott-Wellen.
                </p>

                <!-- 3 Benefit-Punkte -->
                <div class="max-w-6xl mx-auto mb-10 flex md:flex-row flex-col gap-4">
                    <div class="flex items-start gap-3 text-left lg:w-1/3 w-full">
                        <svg class="w-6 h-6 text-blue flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <span class="text-sm">15+ ausgewählte Hype-Aktien im Fokus</span>
                    </div>
                    <div class="flex items-start gap-3 text-left lg:w-1/3 w-full">
                        <svg class="w-6 h-6 text-blue flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <span class="text-sm">Täglich aktuell: Eine Chartanalyse von drei Hype-Aktien jeden Handelstag</span>
                    </div>
                    <div class="flex items-start gap-3 text-left lg:w-1/3 w-full">
                        <svg class="w-6 h-6 text-blue flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <span class="text-sm">Einstiegs- und Ausstiegszonen auf Basis der Elliott-Wellen-Analyse</span>
                    </div>
                </div>

                <!-- CTA-Reihe -->
                <div class="flex flex-col md:flex-row justify-center items-center gap-6 mb-12">
                    <router-link
                        v-if="!ShowPreLiveCountdown"
                        to="/produkte/Hype-Aktien"
                        class="bg-gradient-to-br from-[#11D2D4] to-[#0C7475] text-white px-4 py-4 rounded-full font-bold text-md flex items-center gap-2 hover:bg-blue-dark transition"
                    >
                        Hype-Paket jetzt bestellen
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </router-link>
                    <div v-else class="bg-blue text-white px-2 lg:px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-xs lg:text-md">
                        Hype-Aktien-Paket kaufen ab dem 23.02.2026
                    </div>
                    <div class="text-left">
                        <div class="text-md font-bold text-center lg:text-left">Jetzt nur</div>
                        <div class="text-xl font-bold text-blue">69,95 € / Monat</div>
                    </div>
                </div>

                <!-- Social-Proof-Reihe -->
                <div class="flex flex-wrap justify-center items-center gap-8 max-w-4xl mx-auto">
                    <!-- Avatar-Gruppe -->
                    <div class="flex items-center gap-3">
                        <div class="flex -space-x-2">
                            <img :src="$asset('/hkcm/images/rezensionenBilder.png')" />
                        </div>
                        <div class="text-left text-sm">
                            <div>Bereits über 20.000</div>
                            <div>zufriedene Kunden</div>
                        </div>
                    </div>

                    <!-- App Store -->
                    <div class="text-center">
                        <div class="w-32 h-10 mb-2">
                            <a href="https://apps.apple.com/de/app/hkcm/id6499010943" class="h-auto" target="_blank">
                                <img
                                    alt="Apple Store"
                                    class="object-contain max-h-[50px]"
                                    :src="$asset(i18next().language === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png', 'public')"
                                />
                            </a>
                        </div>
                        <div class="flex items-center justify-center gap-2 text-sm">
                            <span class="font-bold">4.4</span>
                            <img class="w-2/4 object-contain max-h-[180px] lg:w-auto" :src="$asset('/hkcm/images/stars4_5_yellow.png', 'public')" alt="" />
                            <span>1.8k</span>
                        </div>
                    </div>

                    <!-- Google Play -->
                    <div class="text-center">
                        <div class="w-32 h-10 mb-2">
                            <a href="https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1" class="h-auto" target="_blank">
                                <img
                                    alt="Google Play Store"
                                    class="object-contain max-h-[50px]"
                                    :src="$asset(i18next().language === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png', 'public')"
                                />
                            </a>
                        </div>
                        <div class="flex items-center justify-center gap-2 text-sm">
                            <span class="font-bold">4.5</span>
                            <img class="w-2/4 object-contain max-h-[180px] lg:w-auto" :src="$asset('/hkcm/images/stars4_5_green.png', 'public')" alt="" />

                            <span>7.3k</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 3) HERO-VIDEO/IMAGE -->
        <section class="relative -mt-44 mb-20">
            <div class="container mx-auto px-4">
                <div class="relative w-full max-w-5xl mx-auto h-[500px] rounded-3xl shadow-2xl">
                    <div
                        v-if="showCountdown"
                        class="lg:absolute -top-20 -right-14 bg-blue z-10 lg:w-[140px] lg:h-[140px] lg:p-0 p-3 rounded-full text-white text-2xl text-center font-semibold leading-[30px] flex items-center justify-center"
                    >
                        <div class="lg:block flex flex-row"><span class="font-bold text-5xl lg:mr-0 mr-3">20%</span><br class="lg:block hidden" />Rabatt</div>
                    </div>
                    <iframe
                        src="https://iframe.mediadelivery.net/embed/369702/48fb82d7-2d38-4c99-8c82-317a185ca36f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                        loading="lazy"
                        style="border: 0; position: absolute; top: 0; height: 100%; width: 100%"
                        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                        allowfullscreen="true"
                        class="rounded-lg"
                    ></iframe>
                </div>
            </div>
        </section>

        <!-- 4) SECTION -->
        <section class="py-20 bg-white">
            <div class="container mx-auto px-4">
                <h2 class="text-3xl md:text-3xl lg:text-4xl font-bold mb-8 text-blue-dark">
                    Warum Anleger für <span class="bg-gradient-to-r from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Hype-Aktien</span> einen anderen Analyseansatz
                    brauchen
                </h2>
                <div class="prose prose-lg max-w-none text-gray-700 space-y-6">
                    <p>
                        Die Aktienmärkte werden zunehmend von starken Narrativen, Kapitalzuflüssen und Momentum-Bewegungen geprägt. Einzelne Themenbereiche können innerhalb kurzer
                        Zeit enorme Aufmerksamkeit und Dynamik entwickeln.
                    </p>
                    <p>
                        Das Hype-Paket bündelt gezielt Trend- und Zukunftsaktien, die aktuell im Fokus der Märkte stehen. Sektorübergreifend, momentumgetrieben und aktiv kuratiert.
                    </p>
                    <p>Dabei handelt es sich nicht um ein starres Themenpaket, sondern um ein rotierendes, aktiv gesteuertes Analyse-Portfolio.</p>
                    <p>
                        Anhand der Elliott-Wellen-Methodik analysieren wir die ausgewählte Hype-Aktien und liefern klar markierte Einstiegs-, Ausstiegs-, Unterstützungs- und
                        Widerstandsbereiche sowie eine nachvollziehbare Einordnung der Kursdynamik.
                    </p>
                </div>
                <div class="text-center mt-10">
                    <router-link
                        v-if="!ShowPreLiveCountdown"
                        to="/produkte/Hype-Aktien"
                        class="inline-flex items-center gap-2 bg-gradient-to-br from-[#11D2D4] to-[#0C7475] text-white px-4 py-4 rounded-full font-semibold hover:bg-blue-dark transition"
                    >
                        Aktuelle Titel ansehen
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </router-link>
                    <div v-else class="bg-blue text-white px-2 lg:px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-xs lg:text-md">
                        Hype-Aktien-Paket kaufen ab dem 23.02.2026
                    </div>
                </div>
            </div>
        </section>

        <!-- 5) SECTION -->
        <section class="py-20 bg-gradient-to-br from-[#072551] to-[#020E20] text-white">
            <div class="container mx-auto px-4">
                <div class="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
                    <div class="order-1 lg:order-1">
                        <div class="w-full">
                            <img alt="Black Bull Investment Visionär" class="h-full lg:w-auto" :src="$asset('/hkcm/images/hype_paket_LP1.png', 'public')" />
                        </div>
                    </div>
                    <div class="order-2 lg:order-2">
                        <h2 class="text-3xl md:text-4xl font-bold mb-6">
                            Was das <span class="bg-gradient-to-r from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Hype-Paket</span> von klassischen Aktienpaketen
                            unterscheidet
                        </h2>
                        <p class="text-lg mb-4">Das Hype-Paket ist ein fokussiertes Aktienanalyse-Paket für Titel mit:</p>
                        <ul class="space-y-0 mb-6">
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>starkem Markt-Narrativ</span>
                            </li>
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>hoher Aufmerksamkeit</span>
                            </li>
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>überdurchschnittlichem Momentum</span>
                            </li>
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>außergewöhnlichem Chancenprofil</span>
                            </li>
                        </ul>
                        <p class="">Statt breiter Marktabdeckung steht hier bewusste Konzentration im Vordergrund.</p>
                        <p class="mb-4">Weniger Titel, dafür höherer Fokus und aktivere Steuerung.</p>
                        <p class="">Keine ETFs. Keine Indexabbildung.</p>
                        <p class="">Ausschließlich ausgewählte Einzelaktien.</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 6) SECTION – 6 Karten -->
        <section class="py-20 bg-white">
            <div class="mx-auto">
                <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold mx-auto mb-12 text-blue-dark text-center container">
                    So ist das <span class="bg-gradient-to-r from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Hype-Paket</span> aufgebaut
                </h2>
                <div ref="cardsSection" class="overflow-x-auto pb-4 mb-12 cardsSection">
                    <div ref="cardsContainer" class="flex gap-6 min-w-max px-4 cardsSection" :style="{ transform: `translateX(${cardsTranslateX}px)` }">
                        <!-- Karte 1 -->
                        <div class="bg-blue-light p-8 rounded-2xl lg:w-[25rem] w-80 flex-shrink-0">
                            <h3 class="text-xl font-bold mb-4 text-blue-dark text-center">
                                15+ Aktien<br />
                                im Fokus
                            </h3>
                            <div class="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <svg class="w-10 h-10 text-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="10" stroke-width="2" />
                                    <circle cx="12" cy="12" r="6" stroke-width="2" />
                                    <circle cx="12" cy="12" r="2" stroke-width="2" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2v10l6 6" />
                                </svg>
                            </div>
                            <p class="text-black text-center">
                                Das Paket bündelt 15+ ausgewählte Hype-Aktien und wird aktiv rotiert. So bleibt der Fokus auf den Titeln, die aktuell besonders relevante
                                Markttrends und Chancen abbilden.
                            </p>
                        </div>

                        <!-- Karte 2 -->
                        <div class="bg-blue-light p-8 rounded-2xl lg:w-[25rem] w-80 flex-shrink-0">
                            <h3 class="text-xl font-bold mb-4 text-blue-dark text-center">Jeden Tag drei Hype-Aktien in der Analyse</h3>
                            <div class="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <svg class="w-10 h-10 text-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                                </svg>
                            </div>
                            <p class="text-black text-center">
                                Täglich eine schriftliche Analyse von drei der besten Hype-Aktien. Direkt per E-Mail, in Ihrem HKCM-Dashboard und in der App. Über die Woche hinweg
                                wird der reguläre Analyse-Turnus vollständig abgedeckt.
                            </p>
                        </div>

                        <!-- Karte 3 -->
                        <div class="bg-blue-light p-8 rounded-2xl lg:w-[25rem] w-80 flex-shrink-0">
                            <h3 class="text-xl font-bold mb-4 text-blue-dark text-center">Schnelle Reaktionen auf Marktbewegungen</h3>
                            <div class="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <svg class="w-10 h-10 text-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <p class="text-black text-center">
                                Bei starken Kursbewegungen oder wichtigen Ereignissen erhalten Sie sofortige Updates, direkt als Nachricht in Ihrem Dashboard oder in der HKCM-App.
                                So bleiben Sie jederzeit über alle relevanten Marktveränderungen informiert und können schnell reagieren.
                            </p>
                        </div>

                        <!-- Karte 4 -->
                        <div class="bg-blue-light p-8 rounded-2xl lg:w-[25rem] w-80 flex-shrink-0">
                            <h3 class="text-xl font-bold mb-4 text-blue-dark text-center">
                                Übersichtliche<br />
                                Chartbilder
                            </h3>
                            <div class="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <svg class="w-10 h-10 text-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                    />
                                </svg>
                            </div>
                            <p class="text-black text-center">
                                Mit klar markierten Unterstützungen, Widerständen und Zielzonen geben Ihnen die Chartbilder eine wertvolle Einordnung, sowohl auf der Long- als auch
                                auf der Short-Seite. Definierte Einstiegs- und Ausstiegszonen für fundierte Entscheidungen.
                            </p>
                        </div>

                        <!-- Karte 5 -->
                        <div class="bg-blue-light p-8 rounded-2xl lg:w-[25rem] w-80 flex-shrink-0">
                            <h3 class="text-xl font-bold mb-4 text-blue-dark text-center">Für alle Trader und Investoren</h3>
                            <div class="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <svg class="w-10 h-10 text-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                </svg>
                            </div>
                            <p class="text-black text-center">
                                Ob langfristig oder kurzfristig, Sie profitieren stets von klar definierten Einstiegs-, Ausstiegs-, Take-Profit- und Stopmarken, die Ihnen
                                Orientierung und Struktur im Handel bieten.
                            </p>
                        </div>

                        <!-- Karte 6 -->
                        <div class="bg-blue-light p-8 rounded-2xl lg:w-[25rem] w-80 flex-shrink-0">
                            <h3 class="text-xl font-bold mb-4 text-blue-dark text-center">Transparentes Musterportfolio</h3>
                            <div class="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                                <svg class="w-10 h-10 text-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                                    />
                                </svg>
                            </div>
                            <p class="text-black text-center">
                                Wir pflegen ein transparentes Musterportfolio, in dem alle Veränderungen, Positionen und Anpassungen nachvollziehbar dokumentiert werden, sodass Sie
                                jederzeit eine klare Entscheidungsgrundlage haben.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <router-link
                        v-if="!ShowPreLiveCountdown"
                        to="/produkte/Hype-Aktien"
                        class="inline-flex items-center gap-2 bg-gradient-to-br from-[#11D2D4] to-[#0C7475] text-white px-4 py-4 rounded-full font-semibold hover:bg-blue-dark transition"
                    >
                        Hype-Paket jetzt bestellen
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </router-link>
                    <div v-else class="bg-blue text-white max-w-xl mx-auto lg:px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-xs lg:text-md">
                        Hype-Aktien-Paket kaufen ab dem 23.02.2026
                    </div>
                </div>
            </div>
        </section>

        <!-- 7) SECTION – Aktien-Grid -->
        <section class="relative overflow-hidden py-20 bg-gradient-to-bl from-[#11D2D4] to-[#0C7475]">
            <div class="relative container mx-auto px-4 max-w-6xl z-10">
                <div class="flex flex-row justify-between items-center mb-12">
                    <h2 class="text-4xl md:text-3xl font-bold text-white text-left">
                        <span class="text-black">Hype-<br /></span>Aktienpaket
                    </h2>
                    <div>
                        <img
                            alt="Black Bull Investment Visionär"
                            class="w-2/4 object-contain max-h-[180px] lg:w-auto"
                            :src="$asset('/hkcm/images/hype_aktien_compas.png', 'public')"
                        />
                    </div>
                </div>
                <div class="grid md:grid-cols-3 gap-6 mx-auto">
                    <!-- Card A -->
                    <div class="bg-white p-6 rounded-2xl">
                        <h3 class="text-lg font-bold mb-4 text-blue-dark">Cannabis</h3>
                        <ul class="space-y-2 text-black text-sm">
                            <li class="flex gap-3 items-center">
                                <img alt="Aurora Cannabis" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/acb.png', 'public')" />
                                <p class="font-bold">Aurora Cannabis (ACB) – Analyse auf Eis</p>
                            </li>
                            <li class="flex gap-3 items-center">
                                <img alt="Canopy Growth" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/weed.png', 'public')" />
                                <p class="font-bold">Canopy Growth (WEED)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <img alt="Tilray Brands" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/tlry.png', 'public')" />
                                <p class="font-bold">Tilray Brands (TLRY) – Analyse auf Eis</p>
                            </li>
                        </ul>
                    </div>

                    <!-- Card B -->
                    <div class="bg-white p-6 rounded-2xl">
                        <h3 class="text-lg font-bold mb-4 text-blue-dark">Gesundheit & Biotechnologie</h3>
                        <ul class="space-y-2 text-black text-sm">
                            <li class="flex gap-3 items-center">
                                <img alt="Molina Healthcare" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/moh.png', 'public')" />
                                <p class="font-bold">Molina Healthcare (MOH)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <img alt="Moderna" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/mrna.png', 'public')" />
                                <p class="font-bold">Moderna (MRNA)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <img alt="Ocugen" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/ocgn.png', 'public')" />
                                <p class="font-bold">Ocugen (OCGN)</p>
                            </li>
                        </ul>
                    </div>

                    <!-- Card C -->
                    <div class="bg-white p-6 rounded-2xl">
                        <h3 class="text-lg font-bold mb-4 text-blue-dark">Quantencomputing & Technologie</h3>
                        <ul class="space-y-2 text-black text-sm">
                            <li class="flex gap-3 items-center">
                                <img alt="Workday" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/wday.png', 'public')" />
                                <p class="font-bold">Workday (WDAY)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <img alt="Rigetti Computing" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/rgti.png', 'public')" />
                                <p class="font-bold">Rigetti Computing (RGTI)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <img alt="D-Wave Quantum" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/qbts.png', 'public')" />
                                <p class="font-bold">D-Wave Quantum (QBTS)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <span class="w-[30px] h-[30px] rounded-full bg-blue/10"></span>
                                <p class="font-bold">CoStar Group, Inc. (CSGP)</p>
                            </li>
                        </ul>
                    </div>

                    <!-- Card D -->
                    <div class="bg-white p-6 rounded-2xl">
                        <h3 class="text-lg font-bold mb-4 text-blue-dark">Konsumgüter & Dienstleistungen</h3>
                        <ul class="space-y-2 text-black text-sm">
                            <li class="flex gap-3 items-center">
                                <img alt="Estée Lauder Companies" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/elaa.png', 'public')" />
                                <p class="font-bold">Estée Lauder Companies (ELAA)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <span class="w-[30px] h-[30px] rounded-full bg-blue/10"></span>
                                <p class="font-bold">Rollins, Inc. (ROL)</p>
                            </li>
                        </ul>
                    </div>

                    <div class="bg-white p-6 rounded-2xl">
                        <h3 class="text-lg font-bold mb-4 text-blue-dark">Agrar & Chemie</h3>
                        <ul class="space-y-2 text-black text-sm">
                            <li class="flex gap-3 items-center">
                                <img alt="FMC Corporation" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/fmc.png', 'public')" />
                                <p class="font-bold">FMC Corporation (FMC)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <img alt="Nutrien" class="w-[30px]" :src="$asset('/hkcm/images/hype-paket/ntr.png', 'public')" />
                                <p class="font-bold">Nutrien (NTR)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <span class="w-[30px] h-[30px] rounded-full bg-blue/10"></span>
                                <p class="font-bold">Celanese Corporation (CE)</p>
                            </li>
                        </ul>
                    </div>

                    <!-- Card E (Rabatt) -->
                    <div
                        v-if="showCountdown"
                        class="hidden relative overflow-hidden lg:flex bg-[#072551] text-white p-6 rounded-2xl flex-col justify-center items-center text-center"
                    >
                        <div class="relative z-10 text-sm mb-2 font-semibold">20% Rabatt-Code:</div>
                        <div class="relative z-10 text-3xl font-bold mb-2 border-2 bg-blue rounded-lg p-2">{{ formatCountdown() }}</div>
                        <div class="relative z-10 text-sm">Einlösbar bis zum 4.3.2026</div>
                        <img class="w-full absolute z-0 -left-28 top-10 scale-150" :src="$asset('/hkcm/images/bg_candels.png', 'public')" alt="Rabatt Icon" />
                    </div>

                    <!-- Card F -->
                    <div class="bg-white p-6 rounded-2xl">
                        <h3 class="text-lg font-bold mb-4 text-blue-dark">Gesundheit & Biotechnologie</h3>
                        <ul class="space-y-2 text-gray-700 text-sm">
                            <li class="flex gap-3 items-center">
                                <span class="w-[30px] h-[30px] rounded-full bg-blue/10"></span>
                                <p class="font-bold">Boston Scientific Corporation (BSX)</p>
                            </li>

                            <li class="flex gap-3 items-center">
                                <span class="w-[30px] h-[30px] rounded-full bg-blue/10"></span>
                                <p class="font-bold">Zoetis Inc. (ZTS)</p>
                            </li>
                        </ul>
                    </div>

                    <!-- Card E (Rabatt) -->
                    <div
                        v-if="showCountdown"
                        class="lg:hidden bg-gradient-to-br from-blue-dark to-blue text-white p-6 rounded-2xl flex flex-col justify-center items-center text-center"
                    >
                        <div class="text-sm mb-2 font-semibold">20% Rabatt-Code:</div>
                        <div class="text-3xl font-bold mb-2 border-2 border-white rounded-lg p-2">{{ formatCountdown() }}</div>
                        <div class="text-sm">Einlösbar bis zum 4.3.2026</div>
                    </div>
                </div>
            </div>
            <img class="absolute bottom-[-350px] w-96 z-0" :src="$asset('/hkcm/images/compass-bg.png', 'public')" alt="" />
        </section>

        <!-- 8) SECTION -->
        <section class="py-20 bg-gradient-to-br from-[#072551] to-[#020E20] text-white">
            <div class="container mx-auto px-4">
                <div class="grid md:grid-cols-2 gap-12 items-center mx-auto">
                    <div>
                        <h2 class="text-3xl md:text-4xl font-bold mb-6">
                            Nicht nur ein Hype: Wir bieten <span class="bg-gradient-to-r from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">den ganzen Hype</span>
                        </h2>
                        <p class="mb-4">
                            Das Paket ist bewusst breit aufgestellt. Denn in der heutigen Welt gibt es mehr als nur einen Trend. Das Momentum verteilt sich auf verschiedene Märkte,
                            unabhängig voneinander. Und genau von diesen wollen wir profitieren.
                        </p>
                        <p class="mb-4 font-semibold">Unsere Themenfelder:</p>
                        <ul class="space-y-0 mb-6">
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>Healthcare / Biotech / Medizintechnik</span>
                            </li>
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>Software / Daten / Technologie</span>
                            </li>
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>Quantum Computing</span>
                            </li>
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>Agrar / Chemie</span>
                            </li>
                            <li class="flex items-start gap-2">
                                <span class="text-blue-light mt-1">•</span>
                                <span>Konsum / Dienstleistungen</span>
                            </li>
                        </ul>
                        <p>Unser Ziel ist es nicht den Trends hinterherzulaufen, sondern durch strukturierte Analyse davon zu profitieren.</p>
                    </div>
                    <div>
                        <div class="w-full">
                            <img alt="Black Bull Investment Visionär" class="object-contain lg:w-auto" :src="$asset('/hkcm/images/hype_paket_LP2.png', 'public')" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 9) SECTION – Betreuung -->
        <section class="py-20 bg-white">
            <div class="container mx-auto px-4">
                <h2 class="w-auto mx-auto max-w-4xl text-3xl md:text-4xl lg:text-5xl font-bold mb-8 text-blue-dark text-center">
                    Diese Betreuung bieten wir mit unserem <span class="bg-gradient-to-r from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Hype-Paket</span>
                </h2>
                <p class="text-lg text-gray-700 mb-4">Hype-Aktien zeichnen sich durch hohe Dynamik aus. Entsprechend aktiv ist die Analyse-Begleitung.</p>

                <div class="mb-8 px-4">
                    <h3 class="text-xl font-bold text-blue-dark mb-4">Sie erhalten:</h3>
                    <ul class="space-y-0 text-gray-700">
                        <li class="flex items-start gap-3">
                            <span class="text-blue mt-1">•</span>
                            <span>Täglich eine schriftliche Analyse von drei der besten Hype-Aktien.</span>
                        </li>
                        <li class="flex items-start gap-3">
                            <span class="text-blue mt-1">•</span>
                            <span>Klare Handelsmöglichkeiten: Per Mail, direkt in die App (inklusive Push-Benachrichtigung) oder jederzeit im HKCM-Dashboard.</span>
                        </li>
                        <li class="flex items-start gap-3">
                            <span class="text-blue mt-1">•</span>
                            <span>Ob langfristig oder kurzfristig, sie profitieren stets von klar definierten Einstiegs-, Ausstiegs-, Take-Profit- und Stoppmarken.</span>
                        </li>
                        <li class="flex items-start gap-3">
                            <span class="text-blue mt-1">•</span>
                            <span>Übersichtliche Chartbilder mit klar markierten Unterstützungen, Widerständen und Zielzonen.</span>
                        </li>
                        <li class="flex items-start gap-3">
                            <span class="text-blue mt-1">•</span>
                            <span
                                >Schnelle Reaktionen auf Marktbewegungen. Bei starken Kursbewegungen oder wichtigen Ereignissen erhalten Sie sofortige Updates, direkt als
                                Kurznachricht in Ihrem Dashboard oder in der HKCM-App.</span
                            >
                        </li>
                    </ul>
                </div>

                <div class="mb-8">
                    <h3 class="text-xl font-bold text-blue-dark mb-4">Hype-Aktien Turnus:</h3>
                    <p class="text-gray-700">
                        Sie erhalten jeden Tag die Analyse von drei Hype-Aktien. Über die Woche hinweg wird der reguläre Analyse-Turnus vollständig abgedeckt.
                    </p>
                </div>

                <div class="text-center mt-10">
                    <router-link
                        v-if="!ShowPreLiveCountdown"
                        to="/produkte/Hype-Aktien"
                        class="inline-flex items-center gap-2 bg-gradient-to-br from-[#11D2D4] to-[#0C7475] text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-dark transition"
                    >
                        Aktuelle Titel ansehen
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </router-link>
                    <div v-else class="bg-blue text-white px-2 lg:px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-xs lg:text-md">
                        Hype-Aktien-Paket kaufen ab dem 23.02.2026
                    </div>
                </div>
            </div>
        </section>

        <!-- 10) SECTION – Zielgruppe + Accordion -->
        <section class="relative py-20 bg-gradient-to-br from-[#072551] to-[#020E20] text-white">
            <img class="z-0 absolute left-0 hidden lg:block w-full" :src="$asset('/hkcm/images/bg_candels.png', 'public')" alt="" />

            <div class="relative z-10 container mx-auto px-4 max-w-6xl">
                <div class="grid md:grid-cols-2 gap-12">
                    <!-- Linke Spalte: Text -->
                    <div>
                        <h2 class="text-3xl md:text-4xl font-bold mb-6">
                            Nicht für alle <span class="bg-gradient-to-tr from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Anleger</span> - sondern für Momentum-Denker
                        </h2>
                        <p class="mb-6">
                            Das Hype-Paket richtet sich an Anleger, die Markttrends aktiv verfolgen und Chancen in dynamischen Aktienbewegungen strukturiert nutzen möchten.
                        </p>
                        <p class="font-semibold">Das Hype-Paket passt besonders gut zu Ihnen, wenn ...</p>
                    </div>

                    <!-- Rechte Spalte: Accordion -->
                    <div class="space-y-4">
                        <div v-for="(item, index) in accordionItems" :key="index" class="bg-white rounded-lg overflow-hidden">
                            <button class="w-full p-6 text-left flex justify-between items-center hover:bg-white/5 transition" @click="toggleAccordion(index)">
                                <div class="flex items-center gap-4">
                                    <i :class="item.icon" class="text-blue text-5xl"></i>
                                    <span :class="{ 'text-blue': item.isOpen }" class="font-semibold text-lg pr-1 text-black"> {{ item.title }}</span>
                                </div>
                                <svg
                                    class="w-6 h-6 flex-shrink-0 transition-transform text-black"
                                    :class="{ 'rotate-180': item.isOpen }"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            <div v-show="item.isOpen" class="px-6 pb-6 text-black">
                                {{ item.content }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 11) CTA BAND -->
        <section class="py-20 bg-blue text-white">
            <div class="container mx-auto px-4 text-center">
                <h3 class="text-3xl md:text-4xl font-bold mb-4">
                    Passt das zu Ihrer Strategie? <br /><span>Dann ist das <span class="text-blue-dark">Hype-Paket</span> das Richtige für Sie!</span>
                </h3>

                <router-link
                    v-if="!ShowPreLiveCountdown"
                    to="/produkte/Hype-Aktien"
                    class="inline-flex items-center gap-2 bg-white text-blue px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition mb-12"
                >
                    Hype-Paket jetzt bestellen
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </router-link>
                <div v-else class="bg-blue text-white px-2 lg:px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-xs lg:text-md">
                    Hype-Aktien-Paket kaufen ab dem 23.02.2026
                </div>

                <!-- Social Proof + Awards -->
                <div class="flex flex-wrap justify-center items-center gap-8">
                    <div class="flex items-center gap-3">
                        <div class="flex -space-x-2">
                            <img :src="$asset('/hkcm/images/rezensionenBilder.png')" />
                        </div>
                        <div class="text-left text-sm">
                            <div>Bereits über 20.000</div>
                            <div>zufriedene Kunden</div>
                        </div>
                    </div>
                    <div class="w-24 h-24 rounded-lg">
                        <img alt="Black Bull Krypto Insider" class="h-full object-cover" :src="$asset('/hkcm/images/partners/BlackBull24_Krypto_square.png', 'public')" />
                    </div>
                    <div class="w-24 h-24 rounded-lg">
                        <img alt="Black Bull Krypto Insider" class="h-full object-cover" :src="$asset('/hkcm/images/partners/BlackBull25_InvestmentVision.png', 'public')" />
                    </div>
                    <div class="w-24 h-24 rounded-lg">
                        <img
                            alt="Black Bull Krypto Insider"
                            class="w-full object-contain max-h-[180px] lg:w-auto"
                            :src="$asset('/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png', 'public')"
                        />
                    </div>
                </div>
            </div>
        </section>

        <!-- 12) SECTION -->
        <section class="py-20 bg-white">
            <div class="container mx-auto px-4">
                <div class="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
                    <div>
                        <div class="relative w-full h-96">
                            <iframe
                                src="https://iframe.mediadelivery.net/embed/369702/b53af697-0733-4f01-ad8c-2d59b3c045f2?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                loading="lazy"
                                style="border: 0; position: absolute; top: 0; height: 100%; width: 100%"
                                allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                allowfullscreen="true"
                                class="rounded-lg"
                            ></iframe>
                        </div>
                    </div>
                    <div>
                        <h2 class="text-3xl md:text-4xl font-bold mb-6 text-blue-dark">
                            <span class="bg-gradient-to-t from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Hype</span> bedeutet nicht Spekulation - sondern
                            Marktaufmerksamkeit
                        </h2>
                        <p class="text-gray-700">
                            „Hype" beschreibt hier Aktien mit außergewöhnlichem Momentum, großem Marktinteresse und bedeutenden Kapitalzuflüssen. Es steht nicht für unkontrollierte
                            Spekulation. Entscheidend sind die Analysen mit klaren Einstiegs- und Ausstiegszonen auf Basis der Elliott-Wellen-Methodik. Jeder Titel wird
                            professionell analysiert, nicht emotional bewertet.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 13) SECTION – Über HKCM -->
        <section class="py-20 bg-blue-light">
            <div class="container mx-auto px-4 max-w-6xl">
                <div class="grid md:grid-cols-2 items-center gap-12 mb-12">
                    <div class="text-gray-700 space-y-4">
                        <h2 class="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-blue-dark text-center">
                            Wer hinter <span class="bg-gradient-to-t from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">HKCM</span> steht
                        </h2>
                        <p class="text-lg text-center text-gray-700 mb-8">
                            Strukturierte Marktanalyse mit klarer Methodik — transparent, nachvollziehbar und regelmäßig aktualisiert.
                        </p>

                        <p>
                            HKCM steht für strukturierte Marktanalyse statt Meinungsprognose. Unser Fokus liegt darauf, Marktbewegungen methodisch einzuordnen und daraus klare
                            Szenarien sowie Kursmarken abzuleiten.
                        </p>
                        <p>
                            Unsere Analysen basieren auf der Elliott-Wellen-Theorie — nicht, weil sie „kompliziert klingt", sondern weil sie Marktphasen und Korrekturen
                            systematisch beschreibbar macht. Das Ziel ist nicht, den Markt perfekt vorherzusagen, sondern Ihnen ein nachvollziehbares Modell zu geben, mit dem Sie
                            Entscheidungen strukturierter treffen können.
                        </p>
                        <p>
                            Wir arbeiten mit einem szenariobasierten Ansatz. Das bedeutet: Sie erhalten nicht nur eine Richtung, sondern mehrere mögliche Entwicklungen — inklusive
                            klarer Marken, ab wann ein Szenario bestätigt oder verworfen ist. So entsteht Orientierung, gerade in volatilen Marktphasen.
                        </p>
                    </div>
                    <div class="relative">
                        <div class="w-full h-fullbg-gray-300 rounded-2xl">
                            <img alt="Philip Klinkmüller" class="rounded-lg object-contain" :src="$asset('/hkcm/images/team/pk.jpg', 'public')" />
                        </div>
                        <div
                            class="absolute top-[210px] lg:top-1/4 lg:-left-10 bg-white rounded-full lg:px-3 w-full lg:w-[200px] lg:h-40 flex flex-col items-center justify-center shadow-lg"
                        >
                            <div class="text-xs text-black font-bold">Über</div>
                            <div class="text-3xl font-bold text-blue">70%</div>
                            <div class="text-xs text-black font-bold text-center px-2">Trefferquote</div>
                        </div>
                    </div>
                </div>

                <!-- 4 Feature Cards -->
                <div class="grid md:grid-cols-4 gap-6">
                    <div class="bg-white p-6 rounded-2xl text-center">
                        <svg class="w-10 h-10 text-blue flex-shrink-0 mt-1 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <h3 class="text-lg font-semibold text-blue mb-2">Methodik statt Meinung</h3>
                        <p class="text-sm text-gray-600">
                            feste<br />
                            Analyse-Logik
                        </p>
                    </div>

                    <div class="bg-white p-6 rounded-2xl text-center">
                        <svg class="w-10 h-10 text-blue flex-shrink-0 mt-1 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <h3 class="text-lg font-semibold text-blue mb-2">Szenarien statt Prognosen</h3>
                        <p class="text-sm text-gray-600">klar definierte Bedingungen</p>
                    </div>

                    <div class="bg-white p-6 rounded-2xl text-center">
                        <svg class="w-10 h-10 text-blue flex-shrink-0 mt-1 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <h3 class="text-lg font-semibold text-blue mb-2">Kursmarken statt Bauchgefühl</h3>
                        <p class="text-sm text-gray-600">transparente Entscheidungszonen</p>
                    </div>

                    <div class="bg-white p-6 rounded-2xl text-center">
                        <svg class="w-10 h-10 text-blue flex-shrink-0 mt-1 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                            <path
                                fill-rule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <h3 class="text-lg font-semibold text-blue mb-2">Regelmäßige Updates</h3>
                        <p class="text-sm text-gray-600">Anpassungen bei Marktveränderungen</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 14) FINAL CTA -->
        <section class="py-20 bg-gradient-to-b from-[#072551] to-[#020E20] text-white">
            <div class="container mx-auto px-4 max-w-6xl">
                <div class="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
                    <div class="relative">
                        <img alt="" class="rounded-lg object-contain" :src="$asset('/hkcm/images/zugang_zum_hype_aktien_paket.png', 'public')" />
                    </div>
                    <div>
                        <h2 class="text-3xl md:text-4xl font-bold mb-6">
                            Jetzt Zugang zum <span class="bg-gradient-to-t from-[#11D2D4] to-[#0C7475] text-transparent bg-clip-text">Hype-Aktien-Paket</span> sichern
                        </h2>
                        <p class="text-sm mb-8 text-gray-200">Fokussierte Momentum-Analysen mit klaren Szenarien und aktiver Rotation.</p>
                        <div class="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                            <router-link
                                v-if="!ShowPreLiveCountdown"
                                to="/produkte/Hype-Aktien"
                                class="w-full lg:w-3/5 justify-center inline-flex items-center gap-2 bg-gradient-to-t from-[#11D2D4] to-[#0C7475] text-white px-4 py-4 rounded-full font-bold text-md hover:bg-blue-dark transition"
                            >
                                Hype-Paket jetzt bestellen
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </router-link>
                            <div v-else class="bg-blue text-white px-2 lg:px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-xs lg:text-md">
                                Hype-Aktien-Paket kaufen ab dem 23.02.2026
                            </div>
                            <div class="text-xl text-blue font-bold">69,95 € / Monat</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 15) FOOTER -->
        <footer class="bg-white py-8 border-t border-gray-200">
            <div class="container mx-auto px-4">
                <div class="flex flex-col md:flex-row justify-between items-center gap-6">
                    <router-link src="#" class="flex items-center gap-2" to="/produkte/Hype-Aktien">
                        <img class="w-32 h-auto" :src="$asset('/hkcm/images/logo-on-light-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
                    </router-link>
                    <div class="flex gap-6 text-sm text-gray-600">
                        <router-link to="/impressum" class="hover:text-blue">Impressum</router-link>
                        <router-link to="/agb" class="hover:text-blue">AGB</router-link>
                        <router-link to="/datenschutz" class="hover:text-blue">Datenschutz</router-link>
                    </div>
                    <router-link
                        v-if="!ShowPreLiveCountdown"
                        to="/produkte/Hype-Aktien"
                        class="bg-blue text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition"
                    >
                        Aktien-Pakete entdecken
                    </router-link>
                    <div v-else class="bg-blue text-white px-2 lg:px-6 py-3 rounded-full font-semibold hover:bg-blue-dark transition text-xs lg:text-md">
                        Hype-Aktien-Paket kaufen ab dem 23.02.2026
                    </div>
                </div>
            </div>
        </footer>
    </div>

    <!--Popup-->
    <teleport to="body">
        <template v-if="ShowPreLiveCountdown">
            <Popup :overflow-hidden="true" :open="popupOpen" class="px-6" @open="closeAction">
                <img class="w-full" alt="Hype Paket Aktion" :src="$asset('/hkcm/images/hypepopup.png', 'public')" />
            </Popup>
        </template>
    </teleport>
</template>

<script>
import i18next from 'i18next';
import Icon from '../components/miscellaneous/Icon.vue';
import Popup from '../components/miscellaneous/Popup.vue';

export default {
    name: 'HypeAktienLandingPage',
    components: { Icon, Popup },
    data() {
        return {
            accordionItems: [
                {
                    title: 'Sie trendstarke Aktien früh erkennen und einordnen wollen',
                    content:
                        'Sie interessieren sich für Titel, die gerade stark im Marktfokus stehen, nicht erst, wenn der Trend vorbei ist. Sie wollen verstehen, wo Momentum strukturell bestätigt wird und wo Vorsicht geboten ist.',
                    isOpen: true,
                    icon: 'fi fi-rr-arrow-trend-up'
                },
                {
                    title: 'Sie Volatilität nicht fürchten - sondern einordnen möchten',
                    content:
                        'Hype-Aktien bewegen sich oft schneller und stärker als der Gesamtmarkt. Unsere Chartanalysen helfen Ihnen, diese Bewegungen strukturiert zu bewerten, statt nur emotional zu reagieren.',
                    isOpen: false,
                    icon: 'fi fi-rr-shield-check'
                },
                {
                    title: 'Sie mit Szenarien statt Schlagzeilen arbeiten wollen',
                    content: 'Sie möchten Entscheidungen nicht auf Basis von Social-Media-Meinungen oder News-Überschriften treffen, sondern mit klaren Chartanalysen.',
                    isOpen: false,
                    icon: 'fi fi-rr-display-chart-up'
                },
                {
                    title: 'Sie fokussierte Chancenpakete bevorzugen',
                    content: 'Statt 50+ durchschnittlicher Titel bevorzugen Sie eine kuratierte Auswahl stark beobachteter Aktien, aktiv betreut und regelmäßig überprüft.',
                    isOpen: false,
                    icon: 'fi fi-rr-box-alt'
                }
            ],
            countdown: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            countdownTimer: null,
            showCountdown: true,
            ShowPreLiveCountdown: false,
            preliveCountdown: null, // number (hours)
            preliveCountdownTimer: null,
            popupOpen: true,
            cardsTranslateX: 0
        };
    },
    mounted() {
        this.updateRobotsMetaToNoIndex();
        this.updateCountdown();
        this.countdownTimer = setInterval(this.updateCountdown, 1000);
        this.startPreLiveCountdown(); // <-- call ONCE
        window.addEventListener('scroll', this.handleParallaxScroll);
        this.handleParallaxScroll(); // Initialize position
    },
    beforeUnmount() {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
        }

        if (this.preliveCountdownTimer) clearInterval(this.preliveCountdownTimer);

        window.removeEventListener('scroll', this.handleParallaxScroll);
    },
    methods: {
        i18next() {
            return i18next;
        },
        toggleAccordion(index) {
            this.accordionItems[index].isOpen = !this.accordionItems[index].isOpen;
        },
        updateCountdown() {
            const targetDate = new Date('2026-03-04T23:59:59').getTime();
            const now = new Date().getTime();
            const distance = targetDate - now;

            if (distance < 0) {
                this.showCountdown = false;
                this.countdown.days = 0;
                this.countdown.hours = 0;
                this.countdown.minutes = 0;
                this.countdown.seconds = 0;

                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer);
                }

                return;
            }

            this.countdown.days = Math.floor(distance / (1000 * 60 * 60 * 24));
            this.countdown.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.countdown.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            this.countdown.seconds = Math.floor((distance % (1000 * 60)) / 1000);
        },
        formatCountdown() {
            const pad = (num) => String(num).padStart(2, '0');

            return `${pad(this.countdown.days)} : ${pad(this.countdown.hours)} : ${pad(this.countdown.minutes)} : ${pad(this.countdown.seconds)}`;
        },
        startPreLiveCountdown() {
            const targetDate = new Date('2026-02-22T23:29:59').getTime();

            if (this.preliveCountdownTimer) clearInterval(this.preliveCountdownTimer);

            const tick = () => {
                const now = Date.now();
                const distance = targetDate - now;

                if (distance <= 0) {
                    clearInterval(this.preliveCountdownTimer);
                    this.preliveCountdownTimer = null;
                    this.ShowPreLiveCountdown = false;
                    this.preliveCountdown = 0;

                    return;
                }

                this.preliveCountdown = Math.floor(distance / (1000 * 60 * 60));
                this.ShowPreLiveCountdown = true;
            };

            tick();
            this.preliveCountdownTimer = setInterval(tick, 1000);
        },
        closeAction() {
            this.popupOpen = false;
        },
        updateRobotsMetaToNoIndex() {
            const robotsMeta = document.querySelector('meta[name="robots"]');

            if (!robotsMeta) return;

            robotsMeta.setAttribute('content', 'noindex, nofollow');
        },
        handleParallaxScroll() {
            const section = this.$refs.cardsSection;
            const container = this.$refs.cardsContainer;

            if (!section || !container) return;

            // Get section position relative to viewport
            const rect = section.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // Calculate when section is in view (from bottom of viewport to top)
            // Progress goes from 0 (section entering from bottom) to 1 (section leaving at top)
            const sectionTop = rect.top;
            const sectionHeight = rect.height;

            // Start effect when section is about to enter viewport
            const scrollStart = windowHeight;
            const scrollEnd = -sectionHeight;
            const scrollRange = scrollStart - scrollEnd;

            // Calculate scroll progress (0 to 1)
            let progress = (scrollStart - sectionTop) / scrollRange;
            progress = Math.max(0, Math.min(1, progress)); // Clamp between 0 and 1

            // Calculate how much the cards can move
            // Cards container is wider than viewport, so we need to move it to show all cards
            const containerWidth = container.scrollWidth;
            const viewportWidth = section.clientWidth;
            const maxTranslation = containerWidth - viewportWidth;

            // Move from right (0) to left (-maxTranslation) as user scrolls down
            // Start slightly from the right for better visibility
            const startOffset = 2500; // Start 200px from the right edge
            this.cardsTranslateX = startOffset - (progress + 0.4) * (maxTranslation + startOffset);
        }
    }
};
</script>

<style scoped>
.hype-aktien-landing-page {
    scroll-behavior: smooth;
}

.prose {
    max-width: none;
}

.prose p {
    margin-bottom: 1rem;
}

.cardsSection {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.cardsSection::-webkit-scrollbar {
    display: none;
}
</style>
